import React from "react";

import {OfferType} from "../../../offer/types/OfferType";
import {SiteMapOffersType} from "./SiteMapOffersType";

export const SiteMapFlatOffers = () => <SiteMapOffersType offerType={OfferType.FLAT} />;
import React from "react";

import {OfferType} from "../../../offer/types/OfferType";
import {SiteMapOffersType} from "./SiteMapOffersType";

export const SiteMapFlatOffers = () => <SiteMapOffersType offerType={OfferType.FLAT} />;
